import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class FbidetailService {
  FBIapiUrl = this.ConfigService.getAPIBaseUrl() + 'api/FBI/';
  TaxAdviserapiUrl = this.ConfigService.getAPIBaseUrl() + 'api/TaxAdviser/';
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  //getFBIDetails(RegistrationNumber) {
  //  return this.http.get(this.FBIapiUrl + 'GetFBIDetails?CompanyId=' + RegistrationNumber);
  //}
  getTax_Adviser(userID) {
    return this.http.get(this.TaxAdviserapiUrl + 'taxadviser?userID=' + userID);
  }
  insertSubmission(data: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/xml' });
    headers.append('Accept', 'application/xml');
    headers.append('Content-Type', 'application/xml');
    return this.http.post(this.FBIapiUrl + 'FinalSubmission', data, { responseType: 'text' });
  }
  insertdbdata(data) {
    debugger
    let headers = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8'
      })
    }
    //const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post(this.FBIapiUrl + 'insertFbi', data, { responseType: 'text' })
  }
  getFbiDetails(id) {
    return this.http.get(this.FBIapiUrl +"FbiDetails/"+ id)
  }

  GetSubmissionStatus(CompanyId?:any) {
    return this.http.get(this.FBIapiUrl + "GetSubmissionStatus/" + CompanyId)
  }

  getFbiDetailsbyId(id) {
    return this.http.get(this.FBIapiUrl + "getFbiDetailsbyId/" + id)
  }
  GetHMRCResponseByFBIMasterID(id) {
    return this.http.get(this.FBIapiUrl + "Get_HMRCResponse_By_FBI_MasterID/" + id )
  }
  GetRequestByFBIMasterId(id, APPeriodId) {
    debugger
    return this.http.get(this.FBIapiUrl + "Get_Request_By_FBI_MasterId?id=" + id + '&APPeriodId=' + APPeriodId)
  }
  Get_FBI_TreeData( APPeriodId) {  //Added
    debugger
    return this.http.get(this.FBIapiUrl + "Get_FBI_TreeData?APPeriodId=" + APPeriodId)
  }
  GetFBIMasterList(createdby, role) {
    return this.http.get(this.FBIapiUrl + "Get_FBI_Master_List?createdby=" + createdby +"&role="+ role)
  }
  finalValidations(APPeriodId) {
    return this.http.get(this.FBIapiUrl + "FinalValidations?APPeriodId=" + APPeriodId)
  }
}
